<app-navbar [profile]="id"></app-navbar>
<app-visitor-feed [userId]="id" *ngIf="id"></app-visitor-feed>
<!--Show feed here only if not on poviders profile, else go to visitor-feed-->
<app-general-feed *ngIf="!id" [allCases]="false"></app-general-feed>
<app-footer></app-footer>
